import React, { Component, useState, useRef } from "react";
//import { Modal, Button } from "react-bootstrap";
import AddListing from "./AddListing";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faMagnifyingGlass, faArrowRight, faSpinner, faFileInvoice, faUsersLine, faBan, faBook, faFloppyDisk, faCashRegister } from '@fortawesome/free-solid-svg-icons';

import {
    Alert,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Toast,
    ToastHeader,
    ToastBody,
} from "reactstrap";

import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useEffect } from "react";

function EditListingButton(props) {
    const { listItem, editedListing } = props;


    const refEditListing = useRef();

    const [modalOpen, setModalOpen] = useState(false);

    const authUser = useAuthUser();

    const toggleEditModal = () => setModalOpen(!modalOpen);

    //  let show = props.show;

    /*
    const setShow = (val) => {
        show = val;
    }
    */

    /* {
    state = {
      isOpen: false
    };
   */
    //const openModal = () => setIsOpen(true);  //this.setState({ isOpen: true });
    //const closeModal = () => setIsOpen(props.close);

    //const [isOpen, setIsOpen] = useState(false);

    const handleModalClick = () => {
        //console.log("test");
        //
        if (refEditListing.current) {
            refEditListing.current.submitListing();
        }
    };
    const updatedListing = (updList) => {
        if (editedListing)
            editedListing(updList);
        toggleEditModal();
    };

    return (
        <>
            {listItem.listingProfileId &&
                !listItem.isPreview &&
                authUser?.profile.profileId === listItem.listingProfileId && (
                    <button
                    className="btn btn-primary px-1"
                    style={{
                        cursor: "pointer",
                        width: "60%",
                        height: "35px",
                        fontSize: ".8em",
                    }}
                    onClick={() => toggleEditModal()}
                    >
                        <FontAwesomeIcon icon={faEdit} />

                    </button>
                )}

            <Modal isOpen={modalOpen} toggle={toggleEditModal} size="lg">
                <ModalHeader toggle={toggleEditModal}>
                    Add / Edit Tournament Listing
                </ModalHeader>
                <ModalBody>
                    <AddListing ref={refEditListing} listItem={listItem} updatedListing={updatedListing} />
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-primary" onClick={handleModalClick}>
                        Save
                    </button>
                    <button className="btn btn-secondary" onClick={toggleEditModal}>
                        Close
                    </button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default EditListingButton;
